"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutations = void 0;
var react_1 = require("react");
var useDitto_1 = require("../useDitto");
function useMutations(useMutationParams) {
    var ditto = (0, useDitto_1.useDitto)(useMutationParams.path).ditto;
    var update = (0, react_1.useCallback)(function (params) {
        var cursor;
        if (params.query) {
            if (params.args) {
                cursor = ditto.store
                    .collection(useMutationParams.collection)
                    .find(params.query, params.args);
            }
            else {
                cursor = ditto.store
                    .collection(useMutationParams.collection)
                    .find(params.query);
            }
        }
        else {
            cursor = ditto.store.collection(useMutationParams.collection).findAll();
        }
        return cursor.update(params.updateClosure);
    }, [ditto, useMutationParams.collection]);
    var updateByID = (0, react_1.useCallback)(function (params) {
        var pendingIDSpecificOperation = ditto.store
            .collection(useMutationParams.collection)
            .findByID(params._id);
        return pendingIDSpecificOperation.update(function (mutableDoc) {
            params.updateClosure(mutableDoc);
        });
    }, [ditto, useMutationParams.collection]);
    var upsert = (0, react_1.useCallback)(function (params) {
        return ditto.store
            .collection(useMutationParams.collection)
            .upsert(params.value, params.upsertOptions);
    }, [ditto, useMutationParams.collection]);
    var remove = (0, react_1.useCallback)(function (params) {
        var cursor;
        if (params.query) {
            if (params.args) {
                cursor = ditto.store
                    .collection(useMutationParams.collection)
                    .find(params.query, params.args);
            }
            else {
                cursor = ditto.store
                    .collection(useMutationParams.collection)
                    .find(params.query);
            }
        }
        else {
            cursor = ditto.store.collection(useMutationParams.collection).findAll();
        }
        return cursor.remove();
    }, [ditto, useMutationParams.collection]);
    var removeByID = (0, react_1.useCallback)(function (params) {
        return ditto.store
            .collection(useMutationParams.collection)
            .findByID(params._id)
            .remove();
    }, [ditto, useMutationParams.collection]);
    return {
        ditto: ditto,
        update: update,
        updateByID: updateByID,
        upsert: upsert,
        remove: remove,
        removeByID: removeByID,
    };
}
exports.useMutations = useMutations;
//# sourceMappingURL=useMutations.js.map